//src/common/flexytable/FlexyTableBubbleInPop.js
import React from 'react';
import {
    FlexySize, BubbleRowDiv, BubbleColumnDiv, BubbleColumnPair, BubbleBoxForFlexyPopover
} from './FlexyTableStyled';

export default function FlexyTableBubbleInPop({
    columns,
    data,
    maxWidth,
    maxHeight,
    onRequestRemove,
}) {
    var pairCnt = Math.ceil( ( FlexySize.BubbleRowHeight * columns.length ) / (maxHeight - FlexySize.CommonPadding * 4) );
    if(pairCnt > 3) pairCnt = 3;

    const rowCnt = Math.ceil(columns.length / pairCnt);
    const pairs = [];
    for(var i=0;i<pairCnt;i++) {
        // const key = 'A'+i;
        pairs.push( columns.slice(i * rowCnt, (i+1) * rowCnt) );
    }

    const onClickRemoveBox = (e) => {
        if(onRequestRemove) onRequestRemove();
        e.stopPropagation();
    };

    return(
        <BubbleBoxForFlexyPopover
            maxWidth={maxWidth} maxHeight={maxHeight}
            onMouseLeave={onClickRemoveBox}
        >
            {
                pairs.map((pair,idx)=>{
                    return(
                        <BubbleColumnPair key={idx}>
                            <BubbleColumnDiv>
                                {
                                    pair.map((col)=>{
                                        return(
                                            <BubbleRowDiv key={col.id}>
                                                {col.label}
                                            </BubbleRowDiv>
                                        );
                                    })
                                }
                            </BubbleColumnDiv>
                            <BubbleColumnDiv>
                                {
                                    pair.map((col)=>{
                                        return(
                                            <BubbleRowDiv key={col.id}>
                                                {data[col.id]}
                                            </BubbleRowDiv>
                                        );
                                    })
                                }
                            </BubbleColumnDiv>
                        </BubbleColumnPair>
                    );
                })
            }
        </BubbleBoxForFlexyPopover>
    );
}
